<div class="loader-wrapper" id="appLoader">
  <div class="loader bg-white">
    <div class="whirly-loader"></div>
  </div>
</div>